module.exports = __webpack_public_path__ + "static/img/4.2292d30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/4.jpg
// module id = R+M/
// module chunks = 12